import type { PalantirChatMessage } from '@flux/design-system';
import type { ChatMessage } from '../../models/chat.model';

/**
 * Converte a mensagem do client no formato do `palantir-chat`.
 *
 * O `role` já coincide (`'USER' | 'MODEL'` nos dois lados), então não há tradução
 * de papel. O trabalho é levar os campos extra adiante: o `palantir-chat` renderiza
 * `content` e delega o resto ao `messageTemplate`, que decide o que mostrar
 * (raciocínio, componentes de resposta, ações de turno).
 */
export function toPalantirChatMessage(message: ChatMessage): PalantirChatMessage {
  return {
    components: message.components,
    content: message.content,
    failed: message.failed,
    id: message.id,
    reasoning: message.reasoning,
    retryable: message.retryable,
    role: message.role,
  };
}
